export default __webpack_public_path__ + "static/media/telegram.a395254c.svg";